import React from "react";
import Context from "../../Context";
import { Dropdown } from "react-bootstrap";
import { FONT_SIZES, FONT_COLORS, PRESETS } from "./stylemap";

export default class ToolbarB extends React.Component {
  static contextType = Context;

  getCurrentBlockType = () => {
    const { editorState } = this.props;
    const selection = editorState.getSelection();
    const block = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey());
    if (block) {
      return block.getType();
    }
    return null;
  };

  renderInlineButton = (style, label) => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    return (
      <button
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleInline(style);
        }}
        className={`btn btn-icon ${
          currentStyle.has(style) ? "btn-secondary" : "btn-light"
        }`}
      >
        {label}
      </button>
    );
  };

  renderBlockDataButton = (dataStyle, label) => {
    const { onToggleBlockData, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    const selection = editorState.getSelection();
    const blockData = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getData()
      .toJS();
    const dataKey = Object.keys(dataStyle)[0];

    return (
      <button
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleBlockData(dataStyle);
        }}
        className={`btn btn-icon ${
          blockData[dataKey] === dataStyle[dataKey]
            ? "btn-secondary"
            : "btn-light"
        }`}
      >
        {label}
      </button>
    );
  };

  renderBlockButton = (style, label) => {
    const { onToggleBlock } = this.props;
    const blockType = this.getCurrentBlockType();
    return (
      <button
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleBlock(style);
        }}
        className={`btn btn-icon ${
          blockType === style ? "btn-secondary" : "btn-light"
        }`}
      >
        {label}
      </button>
    );
  };

  renderFunctionButton = (id, label) => {
    const { onCallFunction } = this.props;
    return (
      <button
        disabled={!this.props.editorFocused}
        onMouseDown={(e) => {
          e.preventDefault();
          onCallFunction(id);
        }}
        className={`btn btn-icon btn-light`}
      >
        {label}
      </button>
    );
  };

  renderBlockDropdown = () => {
    const { editorState, onCallFunction } = this.props;
    const selection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    const blocks = {
      unstyled: "Обычный абзац",
      nopadding: "Абзац без отступов",
      "header-one": "Заголовок 1",
      grid: "Ячейка сетки",
      table: "Таблица",
      cell: "Таблица",
      "header-two": "Заголовок 2",
      "header-three": "Заголовок 3",
    };

    const hideBlocks = ["grid", "table", "cell"];

    let label = blocks[blockType] || "Обычный абзац";

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {label}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="row px-2 py-1" style={{ width: "500px" }}>
            {blockType === "table" || blockType === "cell" ? (
              <div className="col-6">
                <label className="text-muted p-2 small">
                  Действия в таблице:
                </label>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-select-row");
                  }}
                >
                  Выделить всю строку
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-select-col");
                  }}
                >
                  Выделить весь столбец
                </Dropdown.Item>
                <hr />
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-add-down");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Строку ниже
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-add-right");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Столбец справа
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-remove-row");
                  }}
                >
                  <i className="fa fa-minus mr-2"></i> Удалить строку
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-remove-col");
                  }}
                >
                  <i className="fa fa-minus mr-2"></i> Удалить столбец
                </Dropdown.Item>
                <Dropdown.Item
                  onMouseDown={(e) => {
                    e.preventDefault();
                    onCallFunction("table-remove");
                  }}
                >
                  <i className="fa fa-times mr-2"></i> Удалить таблицу
                </Dropdown.Item>
              </div>
            ) : (
              <div className="col-6">
                <label className="text-muted p-2 small">
                  Изменить тип блока:
                </label>
                {Object.keys(blocks).map((type) => {
                  if (!hideBlocks.includes(type)) {
                    return this.renderBlockDropdownItem(
                      type,
                      blocks[type],
                      blockType
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            )}

            <div className="col-6">
              <label className="text-muted p-2 small">
                Применить набор форматирования:
              </label>
              {PRESETS.map((preset) => {
                return this.renderPresetDropdownItem(preset);
              })}
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderBlockDropdownItem = (style, label, blockType) => {
    const { onToggleBlock } = this.props;
    return (
      <Dropdown.Item
        key={style}
        onMouseDown={(e) => {
          e.preventDefault();
          onToggleBlock(style);
        }}
        className={` ${blockType === style ? "bg-secondary" : ""}`}
      >
        {label}
      </Dropdown.Item>
    );
  };
  renderPresetDropdownItem = (preset) => {
    const { onTogglePreset } = this.props;
    return (
      <Dropdown.Item
        key={preset.name}
        onMouseDown={(e) => {
          e.preventDefault();
          onTogglePreset(preset);
        }}
      >
        {preset.name}
      </Dropdown.Item>
    );
  };

  renderLinesDropdown = () => {
    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          <span className="fa fa-text-height"></span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="text-center">
          <div className="btn-group ">
            {this.renderInlineButton("LH15", "1.5")}
            {this.renderInlineButton("LH2", "2")}
            {this.renderInlineButton("LH25", "2.5")}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderFontsDropdown = () => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    let currentFont = null;

    const fonts = {
      fontArial: "Arial",
      fontTimes: "Times",
      fontComic: "Comic Sans",
      fontCourier: "Courier",
    };

    Object.keys(fonts).forEach((font) => {
      if (currentStyle.has(font)) {
        currentFont = font;
      }
    });

    if (!currentFont) currentFont = Object.keys(fonts)[0];

    let label = fonts[currentFont];

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {label}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.keys(fonts).map((font) => {
            return (
              <Dropdown.Item
                key={font}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggleInline(font);
                }}
                className={` ${currentFont === font ? "bg-secondary" : ""}`}
              >
                {fonts[font]}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderSizesDropdown = () => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    let currentSize = null;

    const sizes = FONT_SIZES;

    sizes.forEach((size) => {
      if (currentStyle.has(`fontSize${size}`)) {
        currentSize = size;
      }
    });

    if (!currentSize) currentSize = 16;

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {currentSize}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {sizes.map((size) => {
            return (
              <Dropdown.Item
                key={size}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggleInline(`fontSize${size}`);
                }}
                className={` ${currentSize === size ? "bg-secondary" : ""}`}
              >
                {size}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderColorsDropdown = () => {
    const { onToggleInline, editorState } = this.props;
    const currentStyle = editorState.getCurrentInlineStyle();
    let currentColor = null;

    const colors = FONT_COLORS;

    colors.forEach((color) => {
      if (currentStyle.has(`fontColor${color}`)) {
        currentColor = color;
      }
    });

    if (!currentColor) currentColor = colors[0];

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          disabled={!this.props.editorFocused}
          variant="light"
          id="dropdown-basic"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          <div className="color-box" style={{ background: currentColor }}></div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {colors.map((color) => {
            return (
              <button
                key={color}
                disabled={!this.props.editorFocused}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onToggleInline(`fontColor${color}`);
                }}
                className={`btn ml-1 mt-1 btn-icon ${
                  currentColor === color ? "btn-secondary" : "btn-light"
                }`}
              >
                <div className="color-box" style={{ background: color }}></div>
              </button>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderButtons = () => {
    let blockType = this.getCurrentBlockType();
    const blockIsTable = blockType === "table" || blockType === "cell";

    return (
      <div>
        <div className="btn-group mr-2">
          {this.renderInlineButton(
            "BOLD",
            <span className="fa fa-bold"></span>
          )}
          {this.renderInlineButton(
            "ITALIC",
            <span className="fa fa-italic"></span>
          )}
          {this.renderInlineButton(
            "UNDERLINE",
            <span className="fa fa-underline"></span>
          )}
        </div>

        <div className="btn-group mr-2">
          {<div className="d-inline-block ">{this.renderFontsDropdown()}</div>}
          {<div className="d-inline-block  ">{this.renderSizesDropdown()}</div>}
          {<div className="d-inline-block">{this.renderColorsDropdown()}</div>}
        </div>

        <div className="btn-group mr-2">
          {this.renderBlockDataButton(
            { align: "left" },
            <span className="fa fa-align-left"></span>
          )}
          {this.renderBlockDataButton(
            { align: "center" },
            <span className="fa fa-align-center"></span>
          )}
          {this.renderBlockDataButton(
            { align: "justify" },
            <span className="fa fa-align-justify"></span>
          )}
          {this.renderBlockDataButton(
            { align: "right" },
            <span className="fa fa-align-right"></span>
          )}
        </div>

        <div className="d-inline-block mr-2">{this.renderBlockDropdown()}</div>

        <div className="btn-group ">
          {this.renderBlockButton(
            "unordered-list-item",
            <span className="fa fa-list-ul"></span>
          )}
          {this.renderBlockButton(
            "ordered-list-item",
            <span className="fa fa-list-ol"></span>
          )}
          {this.renderBlockButton(
            "indent",
            <span className="fa fa-indent"></span>
          )}
          {this.renderBlockButton(
            "outdent",
            <span className="fa fa-outdent"></span>
          )}
          {/*this.renderBlockButton("grid", <span className="fa fa-th"></span>)*/}
          {this.renderBlockButton(
            "table",
            <span className="fa fa-table"></span>
          )}
          {this.renderBlockButton(
            "paragraph",
            <span className="fa fa-paragraph"></span>
          )}
        </div>

        {/*<div className="d-inline-block mr-2">{this.renderLinesDropdown()}</div>*/}
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="editor-toolbar">{this.renderButtons()}</div>
      </>
    );
  }
}
